"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hrCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var hrCountry = exports.hrCountry = function hrCountry(t) {
  return {
    id: 'HR',
    name: t('Croatia'),
    flag: '🇭🇷',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{5}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 10000 or 40000',
    phonePrefix: '385',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Zagreb',
    currency: 'EUR'
  };
};